export default [
  { text: 'Document', value: 'title' },
  { text: 'Doc Date', value: 'docDate' },
  { text: 'Expire Date', value: 'expirationDate' },
  { text: 'Uploaded Date', value: 'creationDate' },
  { text: 'User', value: 'user' },
  { text: 'Notes', value: 'notes' },
];
